<template>
  <div>
    <vue-headful title="Sollicitaties" />
    <Header page_title="Sollicitaties" />
    <div v-if="applicants && applicants.length > 0" class="px-4 mx-2 pb-4">
      <div class="container-fluid px-0 pb-5 mb-3">
        <div class="clearfix mb-3">
          <p class="float-right mb-4">
            <strong>{{ applicants.length }}</strong> sollicitaties
          </p>
          <button hidden type="button" class="btn-filter position-relative p-0 m-0 float-right">
            Filter
            <div class="icon-wrapper d-inline-block">
              <i class="material-icons-round">filter_list</i>
            </div>
          </button>
        </div>
        <div class="applicant-overview mb-4">
            <template v-if="branch != 3">
                  <ApplicantCard
                    v-for="applicant in applicants"
                    :key="applicant.job_applicant_id"
                    :applicant="applicant"
                    :view="true"
                  />
            </template>
            <template v-else>
                <HealthcareApplicantCard
                    v-for="applicant in applicants"
                    :key="applicant.job_applicant_id"
                    :applicant="applicant"
                    :view="true"
                />
            </template>
        </div>
      </div>
    </div>

    <div v-if="declined && declined.length > 0" class="px-4 mx-2 pb-4">
      <div class="container-fluid px-0 pb-5 mb-3">
        <div class="clearfix mb-3">
          <p class="float-right mb-4">
            <strong>{{ declined.length }}</strong> afgewezen sollicitaties
          </p>
          <button hidden type="button" class="btn-filter position-relative p-0 m-0 float-right">
            Filter
            <div class="icon-wrapper d-inline-block">
              <i class="material-icons-round">filter_list</i>
            </div>
          </button>
        </div>
        <div class="applicant-overview mb-4">
          <ApplicantCard
              v-for="applicant in declined"
              :key="applicant.job_applicant_id"
              :applicant="applicant"
              :view="true"
          />
        </div>
      </div>
    </div>

    <Empty v-else-if="(!applicants || !applicants.length) && (!declined || !declined.length)" text="Er zijn geen sollicitaties voor deze vacature." />
    <footer
      v-if="applicants && applicants.length > 0"
      class="bg-white fixed-btn position-fixed w-100"
      hidden
    >
      <div class="px-4 mx-2">
        <div class="container-fluid px-0">
          <a
            role="button"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Filter kandidaten</a
          >
        </div>
      </div>
    </footer>
    <Footer />
  </div>
</template>

<script>
import ApplicantCard from "@/components/Company/ApplicantCard.vue";
import HealthcareApplicantCard from "@/components/Company/HealthcareApplicantCard.vue";

export default {
  data: function() {
    return {
      applicants: null,
      declined: null
    };
  },
    computed: {
      branch: function () {
          return localStorage.getItem("branch");
      }
    },
  props: ["id"],
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.applicants = await this.getTokenAPIList(
          "applicants/" + parseInt(this.id)
      );
      this.declined = await this.getTokenAPIList(
          "applicants/declined/" + parseInt(this.id)
      );
      this.$store.state.loading = false;
    }
  },
  components: {
      HealthcareApplicantCard,
    ApplicantCard
  }
};
</script>

<style scoped>
::v-deep .applicant-link .text.position {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 20px;
}
</style>
